export default {
	label: 'Kasutaja | Kasutajad',
	validIdCode: 'Isikukood peab olema 11 tähe pikkune!',
	validEmail: 'Email peab olema vähemalt 2 tähe pikkune ja sisaldama {symbol}!',
	validPassword: 'Parool peab olema pikem kui 12 tähte!',
	validPassword2: 'Paroolid peavad kattuma!',
}
